"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styledComponentsBreakpoint = _interopRequireDefault(require("styled-components-breakpoint"));

var _reactFontawesome = require("@fortawesome/react-fontawesome");

var _faTimes = require("@fortawesome/pro-regular-svg-icons/faTimes");

var _templateObject, _templateObject2, _templateObject3;

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var ClearFilter = _styledComponents["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    position: absolute;\n    bottom: 1px;\n    right: 6px;\n    height: calc(1.5em + 0.75rem + 2px);\n    width: calc(1.5em + 0.75rem + 2px);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n"])));

var FilterInput = _styledComponents["default"].div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    width: 100%;\n\n    ", ";\n"])), (0, _styledComponentsBreakpoint["default"])('laptop')(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n        width: auto;\n    "]))));

var TextFilter = function TextFilter(_ref) {
  var label = _ref.label,
      placeholder = _ref.placeholder,
      column = _ref.column,
      onApplyFilters = _ref.onApplyFilters,
      setAllFilters = _ref.setAllFilters,
      gotoPage = _ref.gotoPage,
      state = _ref.state,
      step = _ref.step,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'text' : _ref$type,
      _ref$selectedFilters = _ref.selectedFilters,
      selectedFilters = _ref$selectedFilters === void 0 ? [] : _ref$selectedFilters;
  var path = window.location.pathname;
  var claims = window.localStorage.getItem('claims');
  var user = claims ? JSON.parse(claims)['id'] : '';
  (0, _react.useEffect)(function () {
    var storedFilters = JSON.parse(window.localStorage.getItem("".concat(user, "_filterValues").concat(path)));

    if (storedFilters && storedFilters[column.id]) {
      column.setFilter(storedFilters[column.id]);
    }
  }, []);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, selectedFilters[column.id] && /*#__PURE__*/_react["default"].createElement(FilterInput, {
    className: "form-group mb-2 mb-lg-0 mr-lg-2 position-relative"
  }, /*#__PURE__*/_react["default"].createElement("label", null, label), /*#__PURE__*/_react["default"].createElement("input", {
    className: "form-control",
    type: type,
    placeholder: placeholder ? placeholder : label,
    value: column.filterValue || '',
    "data-testid": "text-filter-".concat(label.toLowerCase().replaceAll(' ', '-')),
    onChange: function onChange(e) {
      column.setFilter(e.target.value);
    },
    onKeyDown: function onKeyDown(e) {
      if (e.keyCode == 13 || e.which == 13) {
        onApplyFilters();
        gotoPage(0);
      }
    },
    step: step
  }), column.filterValue && column.filterValue.length > 0 && /*#__PURE__*/_react["default"].createElement(ClearFilter, {
    role: "button",
    onClick: function onClick() {
      delete state[0].filters[column.id];
      setAllFilters(state[0].filters);
      onApplyFilters();
      gotoPage(0);
    }
  }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: _faTimes.faTimes,
    size: "lg"
  }))));
};

TextFilter.propTypes = {
  label: _propTypes["default"].string.isRequired,
  placeholder: _propTypes["default"].string,
  column: _propTypes["default"].shape({
    filterValue: _propTypes["default"].string,
    setFilter: _propTypes["default"].func.isRequired
  }),
  onApplyFilters: _propTypes["default"].func.isRequired
};
var _default = TextFilter;
exports["default"] = _default;